import script from "./vwarehousemanifest.vue?vue&type=script&setup=true&lang=js"
export * from "./vwarehousemanifest.vue?vue&type=script&setup=true&lang=js"

import "./vwarehousemanifest.vue?vue&type=style&index=0&id=12ee8483&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ee8483"]])

export default __exports__